<template lang="pug">
  FormBlock(mobile).b-desc
    ._header Приглашения
    ._items
      ._item
        span._name Плашка с галочкой
        span._text  – приглашение отправлено по e-mail. Пользователь пока его не принял.
      ._item
        span._name Плашка с кружком
        span._text  – приглашение еще не отправлено.
</template>

<script>
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'ProjectInvitationsDescTile',
  components: { FormBlock },
};
</script>

<style scoped lang="scss">
  .desc {
    &__header {
      font-size: 18px;
      line-height: 24px;
      color: var(--color-super-dark);
      padding-bottom: 10px;
      margin-bottom: 18px;
      border-bottom: 1px solid #EBEFF2;
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__name {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #33A1FB;
    }

    &__text {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
    }
  }
</style>
